import LoginOut from './LoginOut';

export default LoginOut;
